/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GuaranteeFilterDto
 */
export interface GuaranteeFilterDto {
    /**
     * Unique identifier of the guarantee
     * @type {string}
     * @memberof GuaranteeFilterDto
     */
    id: string;
    /**
     * Unique identifier of the guarantee
     * @type {string}
     * @memberof GuaranteeFilterDto
     */
    guaranteeTunnelId: string;
    /**
     * Name of the guarantee
     * @type {string}
     * @memberof GuaranteeFilterDto
     */
    name: string;
    /**
     * Short name of the guarantee
     * @type {string}
     * @memberof GuaranteeFilterDto
     */
    shortName?: string;
    /**
     * Short description of the guarantee
     * @type {string}
     * @memberof GuaranteeFilterDto
     */
    shortDescription?: string;
    /**
     * Long description of the guarantee
     * @type {string}
     * @memberof GuaranteeFilterDto
     */
    longDescription?: string;
    /**
     * Indicates if the guarantee is required
     * @type {boolean}
     * @memberof GuaranteeFilterDto
     */
    isRequired: boolean;
    /**
     * List of child guarantees
     * @type {Array<GuaranteeFilterDto>}
     * @memberof GuaranteeFilterDto
     */
    childrens?: Array<GuaranteeFilterDto>;
}

/**
 * Check if a given object implements the GuaranteeFilterDto interface.
 */
export function instanceOfGuaranteeFilterDto(value: object): value is GuaranteeFilterDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('guaranteeTunnelId' in value) || value['guaranteeTunnelId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isRequired' in value) || value['isRequired'] === undefined) return false;
    return true;
}

export function GuaranteeFilterDtoFromJSON(json: any): GuaranteeFilterDto {
    return GuaranteeFilterDtoFromJSONTyped(json, false);
}

export function GuaranteeFilterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuaranteeFilterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'guaranteeTunnelId': json['guaranteeTunnelId'],
        'name': json['name'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'shortDescription': json['shortDescription'] == null ? undefined : json['shortDescription'],
        'longDescription': json['longDescription'] == null ? undefined : json['longDescription'],
        'isRequired': json['isRequired'],
        'childrens': json['childrens'] == null ? undefined : ((json['childrens'] as Array<any>).map(GuaranteeFilterDtoFromJSON)),
    };
}

export function GuaranteeFilterDtoToJSON(json: any): GuaranteeFilterDto {
    return GuaranteeFilterDtoToJSONTyped(json, false);
}

export function GuaranteeFilterDtoToJSONTyped(value?: GuaranteeFilterDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'guaranteeTunnelId': value['guaranteeTunnelId'],
        'name': value['name'],
        'shortName': value['shortName'],
        'shortDescription': value['shortDescription'],
        'longDescription': value['longDescription'],
        'isRequired': value['isRequired'],
        'childrens': value['childrens'] == null ? undefined : ((value['childrens'] as Array<any>).map(GuaranteeFilterDtoToJSON)),
    };
}

